module.exports = function(vars) {
var __t, __p = '';
__p += '<!-- <div id="background-overlay"></div> -->\n<!-- play overlay prevents clicks on FP elements -->\n<!-- <div id="play-overlay"></div> -->\n<div id="player-overlay" aria-label="Player splash screen, press space bar to load video"></div>\n<div class="player-lock"></div>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/player.ejs